"use client";

import { type AccessTokenPayload, AuthenticationProvider } from "@pharaday/auth";
import { PHARADAY_BANNER } from "@pharaday/env";
import { FeatureFlagContainer, FeatureFlagIdentificationService } from "@pharaday/feature-flag";
import { Layout, LighthouseProvider, TopBanner } from "@pharaday/lighthouse";
import { getQueryClient } from "@pharaday/utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";
import "reflect-metadata";

import { DockyardCentralContainer } from "../core/container";

type ClientProvidersProps = PropsWithChildren;

const ClientProviders = ({ children }: ClientProvidersProps) => {
  const queryClient = getQueryClient();

  const handleAuthenticated = (payload: AccessTokenPayload) => {
    FeatureFlagContainer.get(FeatureFlagIdentificationService).identify(payload.id, {
      organizationId: payload.organizationId,
    });
  };

  const handleUnauthenticated = () => FeatureFlagContainer.get(FeatureFlagIdentificationService).reset();

  return (
    <LighthouseProvider>
      <QueryClientProvider client={queryClient}>
        <AuthenticationProvider
          signOutRedirectUrl="/login"
          onAuthenticated={handleAuthenticated}
          onUnauthenticated={handleUnauthenticated}
        >
          <Layout.Provider banner={Boolean(DockyardCentralContainer.get(PHARADAY_BANNER))}>
            <TopBanner content={DockyardCentralContainer.get<string>(PHARADAY_BANNER)} />
            {children}
          </Layout.Provider>
        </AuthenticationProvider>
      </QueryClientProvider>
    </LighthouseProvider>
  );
};

export default ClientProviders;
